var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"myInput",attrs:{"type":"text"}}),_c('input',{ref:"myInput2",attrs:{"type":"text"}}),_c('input',{ref:"myInput3",attrs:{"type":"text"}}),_c('input',{ref:"myInput4",attrs:{"type":"text"}}),_c('button',{on:{"click":_vm.focusOnInput}},[_vm._v("Focus on the input")])])
}
var staticRenderFns = []

export { render, staticRenderFns }